import { useMemo } from "react";
import Avatar from "./Avatar";
import { useDepartmentsQuery } from "../api/queries/departments";

/**
 * Обертка над Avatar для использования в карточках, таблицах и списках.
 * При наведении показывает ФИО и основной отдел сотрудника.
 */
export default function EmployeeCardLink({
  employee,
  size = "sm",
  className = "",
  ...rest
}) {
  const departmentsData = useDepartmentsQuery().data;
  const departments = useMemo(() => departmentsData ?? [], [departmentsData]);

  const primaryDept = useMemo(() => {
    if (!employee || !employee.departments) return null;
    const p =
      employee.departments.find((d) => d.primary) || employee.departments[0];
    return p ? departments.find((d) => d.id === p.deptId) : null;
  }, [employee, departments]);

  if (!employee) return null;

  const title = `${employee.first} ${employee.last}${
    primaryDept ? ` (${primaryDept.name})` : ""
  }`;

  return (
    <span className={`employee-card-link ${className}`} title={title} {...rest}>
      <Avatar employee={employee} size={size} />
    </span>
  );
}
